<template>
    <div class="level-system">
        <ul class="level-system__items">
            <li class="level-system__item"
                v-html="$options.filters.master(rank[lvSystem.from])">
                {{ rank[lvSystem.from] }}
            </li>
            <li class="level-system__item d-flex align-center"
                v-for="item in lvSystem.steps"
                :class="evaluateActiveClasses(item)">
                <div class="label-system__info">
                    <div class="level-system__name">
                        {{ $vuetify.lang.t('$vuetify.rank.step', item.name) }}
                        <v-icon color="grey" size="14" class="ml-1" v-if="item.availableDate">mdi-lock</v-icon>
                        <v-icon class="ml-1" v-if="item.state === 'done'">mdi-check-circle</v-icon>
                    </div>
                    <div class="level-system__retry text--grey"
                         v-if="item.repeatLevel">{{ $vuetify.lang.t('$vuetify.rank.retry') }}
                    </div>
                </div>
                <div v-if="item.name === 1 && step2 && step2.state !== 'not_available'"
                     class="font-p2 text--grey text-uppercase ml-auto">
                    {{ resolveRankTranslation(item.state, item.availableDate) }}
                </div>
                <label-badge v-else
                             class="ml-auto"
                             :title="resolveRankTranslation(item.state, item.availableDate)"
                             :state="item.state"
                             :step="item.name"
                             :date="item.availableDate"
                             :from="lvSystem.from" />
            </li>
            <li class="level-system__item"
                :class="classesTo"
                v-html="$options.filters.master(rank[lvSystem.to])"></li>
        </ul>
    </div>
</template>
<script>
import LabelBadge from './LabelBadge';
import Pane from './Pane';
import {RANK} from '../utils/constants';

export default {
    name: 'LevelSystem',
    components: {
        LabelBadge,
        Pane,
    },
    props: {
        lvSystem: {},
    },
    data() {
        return {
            dialog: false,
        };
    },
    methods: {
        evaluateActiveClasses(step) {
            const state = [];
            const activeClass = 'level-system__item--active';
            const succeededActiveClass = 'level-system__item--succeeded';
            const downActiveClass = 'level-system__item--down';
            const rankSavedActiveClass = 'level-system__item--rank_saved';

            if ((step.name === 1 || step.name === 2) && (step.state === 'in_progress' || step.state === 'rank_saved' || step.state === 'down')) {
                state.push(activeClass);
            }

            if (step.state === 'down') {
                state.push(downActiveClass);
            }

            if (step.state === 'rank_saved' && this.lvSystem.from === 'ultimate_master') {
                state.push(succeededActiveClass);
            } else if (step.state === 'rank_saved') {
                state.push(rankSavedActiveClass);
            }

            if (step.name === 1 && this.step2 && this.step2.state === 'not_available') {
                state.push(activeClass);
            }

            if (step.name === 2 && this.step2 && this.step2.state === 'succeeded') {
                state.push(activeClass);
                state.push(succeededActiveClass);
            }

            return state;
        },
        resolveRankTranslation(state, date) {
            if (state === 'not_available') {
                return this.$vuetify.lang.t(`$vuetify.rank.from`, this.$options.filters.date(date));
            } else if (state === 'down') {
                return this.$vuetify.lang.t(`$vuetify.rank.states.in_progress`);
            } else if (state === 'rank_saved' && this.lvSystem.from === 'ultimate_master') {
                return this.$vuetify.lang.t(`$vuetify.rank.states.succeeded`);
            } else {
                return this.$vuetify.lang.t(`$vuetify.rank.states.${state}`);
            }
        },
    },
    computed: {
        step1() {
            return this.lvSystem.steps && this.lvSystem.steps.length >= 1 ? this.lvSystem.steps[0] : false;
        },
        step2() {
            return this.lvSystem.steps && this.lvSystem.steps.length >= 2 ? this.lvSystem.steps[1] : false;
        },
        rank() {
            return RANK;
        },
        classesTo() {
            return {
                ['level-system__item--active']: this.step1.state === 'succeeded' && this.step2.state === 'succeeded' || (this.step1.state === 'succeeded' || this.step1.state === 'rank_saved') && !this.step2,
                ['level-system__item--succeeded-full']: this.step1.state === 'succeeded' && this.step2.state === 'succeeded' || (this.step1.state === 'succeeded' || this.step1.state === 'rank_saved') && !this.step2,
            }
        },
    },
};
</script>